function deferFilterjQuery() {
    if (window.jQuery) {
        var $ = window.jQuery;
        $(function(){
          
          // On load/reload
          var pt_on_load = function() {
            // Accordion
            

            // Search
            $('.pt-display-search').not('.has_group_selected').find('input.fm-search-box').show();

            // Drop downs
            $('.pt-display-dropdown').each(function( index ) {
                $(this).find('h4').after($(this).find('.filter-clear'));
            });

            $('.pt-display-dropdown .scroll-content').each(function( index ) {
                if($(this).parent().find('.menu-trigger').length === 0) {
                    if($(this).find('li.selected').length) {
                        var selected = $.map(
                            $(this).find('li.selected a'),
                                function(element){
                                    return $(element).text();
                                }
                        ).join(", ");

                        if (selected.length < 30) {
                            $(this).before('<div class="menu-trigger">' + selected +'</div>');
                        } else {
                            $(this).before('<div class="menu-trigger">' + $(this).find('li.selected').length + ' Selected </div>');
                        }
                    }
                    else {
                        $(this).before('<div class="menu-trigger">'+ $(this).closest('.filter-group').find('h4').text() +'</div>');
                    }
                }
            });

            //Sticky Mode
             // end sticky enable

            // View more
            

            $('.filter-menu li a').attr('title', function() {
              return ($(this).closest('li').hasClass('selected') ? "Clear filter: " : "Add filter: ") + $(this).text();
            });

            // Handle nested filters
            var splitPath = function(url) {
              var splitUrl =  url.split('?')[0].split('#')[0].split('/');
              return splitUrl;
            }

            var getCollection = function(url) {
              var splitUrl = splitPath(url);
              return splitUrl[2];
            }

            var getTags = function(url) {
              var splitUrl = splitPath(url);
              return (splitUrl[3] || '').split('+');
            }

            var getCommonCollection = function(url_top, url_nested) {
              var collection_top = getCollection(url_top);
              var collection_nested = getCollection(url_nested);
              if (collection_top !== collection_nested) {
                return 'all';
              }
              return collection_top;
            }

            var getCommonTags = function(url_top, url_nested) {
              var tags_top = getTags(url_top);
              var tags_nested = getTags(url_nested);

              return tags_top.filter(function(n) {
                return tags_nested.indexOf(n) > -1;
              });
            }

            var getCommonUrl = function(url_top, url_nested) {
              var val = '/collections/' + getCommonCollection(url_top, url_nested) + '/' + getCommonTags(url_top, url_nested).join('+');

              var lastChar = val.slice(-1);
                    if (lastChar == '/') {
                    val = val.slice(0, -1);
                }

              return val;
            }

            var clearNestedParent = $('.pt-display-nested').prev().each(function() {
              var clearNested = $(this).next().find('a.filter-clear').attr('href');
              if (!clearNested) return;
              var clearLink = $(this).find('a.filter-clear');
              clearLink.attr('href', getCommonUrl(clearLink.attr('href'), clearNested))
              var filterLinks = $(this).find('li.selected .collection-name a').each(function() {
                $(this).attr('href', getCommonUrl($(this).attr('href'), clearNested))
              })
            })
          }

          pt_on_load();

          // Mobile filter button
          
          $(document).on('click', '.filter-menu .pt-mobile-header a', function(e){
            if(e.handled !== true) {
              if ($('.pt-nav-toggle').hasClass('active')) {
                $('.filter-menu').removeClass('pt-expand');
                $('.pt-display-dropdown .scroll-content').hide();
              } else {
                $('.filter-menu').addClass('pt-expand');
              }

              $('.pt-nav-toggle').toggleClass('active');
              e.preventDefault();
              e.handled = true;
            }
          });

          

          // Accordion
          

          // Search
          $(document).on('keyup', '.filter-group input.fm-search-box', function () {
            var value = this.value.toLowerCase();
            $(this).closest('.filter-group').find('li').each(function () {
              if ($(this).text().toLowerCase().search(value) > -1) {
                $(this).show(100);
              } else {
                $(this).hide(100);
              }
            });
          });

          // Drop downs
          $(document).on('click','.pt-display-dropdown .menu-trigger',function() {
            $(this).next('.scroll-content').css('top', $(this).position().top + $(this).height() + 1).css('left', $(this).position().left);
            $(this).next('.scroll-content').slideToggle('fast');
          });

          $(document).on('mouseleave', '.pt-display-dropdown .scroll-content', function() {
            $(this).slideUp('fast');
          });

          // Apply button
          

          // Ajax
          
          $.getScript("//trade.designpublicgroup.com/cdn/shop/t/105/assets/jquery.pjax.js?v=138580039773092267901674474159").done(function(script, textStatus) {
            $body = $("body");
            $(document).pjax('.main-content .filter-group a, .main-content .pagination a', '.main-content', { fragment: '.main-content', timeout: 10000, scrollTo: false, push: true });
            $(document).on('pjax:start', function(){ $body.addClass("pt-ajax-loading"); $('.main-content').fadeTo('slow', 0.8); })
            $(document).on('pjax:end', function(){ $body.removeClass("pt-ajax-loading"); $('.main-content').fadeTo('fast', 1); pt_on_load(); $("img.lazy-image").lazyload(); $("html, body").animate({ scrollTop: 0 }, 600); });
          });
          
      });

      //loadScript();
    }
    else {
        setTimeout(function() { deferFilterjQuery() }, 50);
    }
}

deferFilterjQuery();


// BOLD

var _cartSubTotal = 0;
var _cartItemSubTotal = [];

var splitAndTotal = function(quantity, _string){
  _string = _string.split(',');

  var num = 0;

  for(var n=0; n<_string.length; n++) {
    num += Number(_string[n]);
  }

  return quantity ? (num * quantity) : num;
};


var _itemLoop = function(_items){
  var totalRow = document.querySelectorAll('.cart__row.table__section'); //$('.cart__row.table__section'); 
  
  for(var i=0; i<_items.length; i++) {
    var item = _items[i];
    var row = totalRow[i];

    //as we integrated default checkout flow form tradeprogram users PD-261
    if($.inArray('tradeprogram', searchCustomerTags) > 0) {
      var linePrice = item.price;
    } else {
      var linePrice = item.final_price;
    }

    var rowItemPrice = Number(linePrice);
    var rowToltaPrice = rowItemPrice * item.quantity;
    var boldVPrice = item.properties._boldVariantPrices ? item.properties._boldVariantPrices.split(',') : 0;
    var boldVQtys = item.properties._boldVariantQtys ? item.properties._boldVariantQtys.split(',') : 0;
    //var boldItemPrice = boldVQtys ? (boldVQtys * Number(boldVPrice)) : splitAndTotal(false, boldVPrice);
    //var boldTotalPrice = boldVQtys ? (boldVQtys * Number(boldVPrice)) : splitAndTotal(item.quantity, boldVPrice);
    var discount = row && row.getAttribute('data-discount') ? Number(row.getAttribute('data-discount')) : 0;
    var boldItemPrice = 0;
  	var boldTotalPrice = 0;
    var allProperties = item.properties;
    
    var _boldVariantPricesNew = '';
  	var _boldVariantQtysNew = '';
    
    if(boldVQtys) {
      for(var k=0; k<boldVQtys.length; k++) {
        var qt = boldVQtys[k].indexOf('*') === -1 ? item.quantity : parseInt(boldVQtys[k]);
        
        boldItemPrice += 1 * Number(boldVPrice[k]);
        boldTotalPrice += qt * Number(boldVPrice[k]);
        
        _boldVariantPricesNew += (_boldVariantPricesNew ? ',' : '') + boldVPrice[k];
      	_boldVariantQtysNew += (_boldVariantQtysNew ? ',' : '') + (boldVQtys[k].indexOf('*') === -1 ? qt : (qt + '*'));
      }
      
      
      /*console.log('_boldVariantPrices: ' + item.properties._boldVariantPrices);
      console.log('_boldVariantQtys: ' + item.properties._boldVariantQtys);
      console.log('_boldVariantPricesNew: ' + _boldVariantPricesNew);
      console.log('_boldVariantQtysNew: ' + _boldVariantQtysNew);*/

      if(_boldVariantQtysNew !== item.properties._boldVariantQtys) {
        allProperties._boldVariantQtys = _boldVariantQtysNew;

        jQuery.post('/cart/change.js', {
          line: (i + 1),
          quantity: item.quantity,
          properties: allProperties
        });
      }
      
    } else if(boldVPrice && boldVPrice.length) {
      for(var k = 0; k < boldVPrice.length; k++) {
        boldItemPrice += 1 * Number(boldVPrice[k]);
        boldTotalPrice += item.quantity * Number(boldVPrice[k]);
      }
      //boldItemPrice = Number(boldVPrice[0]);
      //boldTotalPrice = Number(boldVPrice[0]) * item.quantity;
      
    }
    
    

    rowItemPrice = rowItemPrice + boldItemPrice;
    rowItemPrice = ((rowItemPrice - (rowItemPrice * discount))/100)*100;

    rowToltaPrice = rowToltaPrice + boldTotalPrice;
    rowToltaPrice = ((rowToltaPrice - (rowToltaPrice * discount))/100)*100;

    _cartSubTotal += rowToltaPrice;
    _cartItemSubTotal[item.key] = rowToltaPrice;

    if(row) {
      var item_price = row.querySelectorAll('.item_price')[0];
      var item_strike_price = row.querySelectorAll('.item_strike_price')[0];
      var item_total_price = row.querySelectorAll('.item_total_price')[0];

      if(item_price) {
        item_price.innerHTML = window.BOLD.common.Shopify.formatMoney(rowItemPrice, window.BOLD.common.Shopify.shop.money_format);
      }
      
      if(item_strike_price) {
        item_strike_price.innerHTML = window.BOLD.common.Shopify.formatMoney((linePrice + boldItemPrice), window.BOLD.common.Shopify.shop.money_format);
      }

      if(item_total_price) {
        item_total_price.innerHTML = window.BOLD.common.Shopify.formatMoney(rowToltaPrice, window.BOLD.common.Shopify.shop.money_format);
      }
    }

  }
};
  
  
  
document.addEventListener('DOMContentLoaded', function(){
  _itemLoop(window.boldCart.items);
  $('.price-span-total, .cart-subtotal').html(Shopify.formatMoney(_cartSubTotal, window.money_format));
  if (typeof window.updateNegotiatedFreightFromSubtotal === 'function' && window.negotiatedFreightRate) {
    window.updateNegotiatedFreightFromSubtotal(window.negotiatedFreightRate);
  }
  /*var _originalPrice = (_cartSubTotal / 100) / (1 + (6.5 / 100));
  
  var _surcharge = ((_cartSubTotal / 100) - _originalPrice).toFixed(2);
  $('.cart__subtotal-title').append('<b> <u>Including Surcharge ($' + _surcharge + ')</u> :</b>');*/
}, false);

function loadOroginalLogo(ele) {
  let url = $(ele).data('logo');
  console.log(url);
  $(ele).closest('a').css('background-image', 'url("' + url + '")').addClass('cls-default-logo');
}

$(document).ready(()=> {
  let src = $('.site-header-opacity .hidden-logo').attr('src');
  $('.site-header-opacity .hidden-logo').attr('src', src);
});

$('.bold_option_price_display').on('change.price', function(e, format) {
  let next_price_span = $(this).next("#ProductPrice");
  let price = $(this).text().replace(/[^0-9.]/gi, "");
  
  if(next_price_span.length) {
    let discountPercentage = next_price_span.attr("data-discount");
    discountPercentage = Number(discountPercentage);
    price = Number(price);
    if(discountPercentage >= 0 && price >= 0 ) {
      price = price * 100;
      var discountPrice = ((price - (price * discountPercentage))/100)*100;
      next_price_span.html(Shopify.formatMoney(discountPrice, format));
    }
  }
});

